/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const authorStatisticsModelSchema = z.object({
    "id": z.string().uuid().describe("Идентификатор автора"),
"nickname": z.string().describe("Никнейм автора"),
"likesCount": z.number().int().describe("Лайков"),
"dislikesCount": z.number().int().describe("Дизлайков"),
"tracksListensCount": z.number().int().describe("Прослушиваний треков (включений)"),
"tracksListens50Count": z.number().int().describe("Прослушиваний треков (>50%)"),
"tracksListens75Count": z.number().int().describe("Прослушиваний треков (>75%)"),
"tracksListens95Count": z.number().int().describe("Прослушиваний треков (>95%)"),
"tracksLikesCount": z.number().int().describe("Лайков треков"),
"tracksDislikesCount": z.number().int().describe("Дизлайков треков"),
"tracksSearchCount": z.number().int().describe("Поисков треков"),
"tracksSwapsCount": z.number().int().describe("Переключений треков"),
"tracksSharesCount": z.number().int().describe("Нажатий кнопки поделиться для треков"),
"tracksPlaylistsCount": z.number().int().describe("Добавлений в плейлист треков")
    })